<header class="attachment-preview-modal__header">
  <h1 class="attachment-preview-modal__title">{{ data.name }}</h1>

  <div class="attachment-preview-modal__actions">
    @if (data.hasDownloadAction && !isPdfDocument) {
      <button sim-icon-button simColor="gray" class="attachment-preview-modal__action-btn" (click)="download()">
        <sim-icon icon="download" sizeType="medium" />
      </button>
    }

    <button sim-icon-button simColor="gray" class="attachment-preview-modal__action-btn" (click)="close()">
      <sim-icon icon="close2" sizeType="medium" />
    </button>
  </div>
</header>

<div class="attachment-preview-modal__content">
  @if (isPhotoDocument) {
    @if (slideshowCollection$ | async; as collection) {
      <common-slideshow
        class="attachment-preview-modal__slideshow"
        type="image"
        [collection]="collection"
        [currentIndex]="0"
      />
    } @else {
      <sim-spinner />
    }
  } @else if (isVideoDocument) {
    @if (mediaSource$ | async; as videoSource) {
      <video class="attachment-preview-modal__video" controls autoplay [src]="videoSource"></video>
    } @else {
      <sim-spinner />
    }
  } @else if (isPdfDocument) {
    @if (pdfSource$ | async; as pdfSource) {
      <iframe class="attachment-preview-modal__pdf" [src]="pdfSource" [title]="data.name"></iframe>
    } @else {
      <sim-spinner />
    }
  } @else {
    <div class="attachment-preview-modal__fallback">
      <sim-icon [icon]="fallbackIcon" [sizeInPx]="96" color="#FFFFFF" />

      @if (isAudioDocument) {
        <span class="attachment-preview-modal__fallback-label" i18n="@@DOCUMENTS_TYPE_AUDIO">Audio</span>
        @if (mediaSource$ | async; as audioSource) {
          <audio class="attachment-preview-modal__audio" controls [src]="audioSource"></audio>
        } @else {
          <sim-spinner />
        }
      } @else {
        <span class="attachment-preview-modal__fallback-label" i18n="@@NO_PREVIEW_AVAILABLE">No preview available</span>
      }
    </div>
  }
</div>
